import AppHeader from "@/components/AppHeader";
import Main from "@/components/Main";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div className="min-h-screen bg-transparent">
      <Seo title="About ElementPad" description="The story behind ElementPad: a free interactive chemistry platform built to help teachers and students." path="/about" />
      <AppHeader />
      <Main className="py-12">
        <article className="max-w-[680px] mx-auto px-4 space-y-6 text-foreground">
          <header>
            <h1 className="text-3xl font-bold mb-2">About</h1>
            <p className="text-muted-foreground text-sm">The story behind ElementPad</p>
          </header>

          <section className="space-y-4 text-base leading-relaxed text-muted-foreground">
            <p>
              My name is <strong className="text-foreground">Kishor</strong>. I built this for my wife{" "}
              <strong className="text-foreground">Kritanjali</strong>, who teaches chemistry. She needed something that
              could make teaching a little simpler. Fewer scattered resources,fewer workarounds,just tools that actually
              help her in the classroom. That's how ElementPad was born.
            </p>
            <p>
              I'm a Data Engineer by day, so I work with pipelines and datasets mostly. But this had nothing to do with
              work. Kritanjali needed something, I figured I could build it, so I did. The development process was
              highly iterative and hands-on.
            </p>
            <p>
              I combined my engineering mindset with the power of AI coding tools, allowing me to rapidly prototype and
              build out the features as needed. It wasn't a strictly formalized roadmap, but a guided, continuous build
              and a focused effort to solve a real problem.
            </p>
            <p>Just me trying to make my wife's job a little easier.</p>
          </section>
        </article>
      </Main>
    </div>
  );
}
